var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isProductFetching)?_c('ProductForm',{attrs:{"productDetail":_vm.productDetail,"isDefault":_vm.isDefault,"update":true},on:{"saveDetail":_vm.saveCustomProduct}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }